import React from 'react'
import ResultsDescription from '../components/ResultsDescription'
import { useTranslation } from 'react-i18next'

import useFetchUserInfo from '../hooks/useFetchUserInfo'

const Cognitive: React.FC = () => {
  const { analysisData, loading, error } = useFetchUserInfo()

  const { t } = useTranslation()
  const yAxisLabels = t('myEvolution.cognitive.chart.yAxisLabels', {
    returnObjects: true,
  }) as string[]

  return (
    <div className="flex h-full gap-6 justify-start flex-1 pt-8 pb-6 px-6  w-full">
      <div className="flex flex-col w-full max-w-[830px]">
        <ResultsDescription
          data={analysisData}
          scoreKey="PFEIFFER"
          description={t(
            'myEvolution.cognitive.resultsDescription.description',
          )}
          title={t('myEvolution.cognitive.resultsDescription.title')}
          modalLink={t('myEvolution.cognitive.resultsDescription.modalLink')}
          chartTitle={t('myEvolution.cognitive.resultsDescription.chartTitle')}
          chartDescription={t(
            'myEvolution.cognitive.resultsDescription.chartDescription',
          )}
          modalDescription={t(
            'myEvolution.cognitive.resultsDescriptionModal.description',
          )}
          modalTitle={t('myEvolution.cognitive.resultsDescriptionModal.title')}
          modalButton={t(
            'myEvolution.cognitive.resultsDescriptionModal.button',
          )}
          loading={loading}
          error={error}
          loadingText={t('myEvolution.cognitive.resultsDescription.loading')}
        />
      </div>
    </div>
  )
}

export default Cognitive
